<template>
  <TTabsToggle
    :header="$t('forms.rating_title')"
    toggle-show
    :default-displayed="showQuestion"
    default-open
    no-move
    data-testid="rating-question-tab"
    @showBlock="showQuestion = true"
    @hideBlock="showQuestion = false"
  >
    <menu-content-container :padding-left-right="8">
      <content-row>
        <TInput
          v-model="questionText"
          :label="$t('forms.rating_title_text')"
          :placeholder="$t('forms.rating_title_placeholder')"
          data-testid="rating-question-text"
        />
      </content-row>
    </menu-content-container>
    <menu-content-container :padding-left-right="8">
      <FontSizeColor
        :data-testid="`question-text-settings`"
        block-name="questionAttributes"
        no-border
      />
    </menu-content-container>
    <PaddingForm
      :external-padding="padding.model"
      external-usage
      :label="$t('forms.padding_label')"
      :changed="padding.changed"
      :default-value="padding.defaultValue"
      data-testid="question-padding-form"
      @paddingChanged="padding.model = $event"
      @reset="padding.reset"
    />
  </TTabsToggle>
</template>

<script setup lang="ts">
  import FontSizeColor from "./fontSizeColorRating.vue";
  import PaddingForm from "../paddingForm.vue";

  import { useMjmlStore } from "@/stores/mjmlStore";
  import { useBlockAttr } from "@/composables/useBlockAttr";
  import { TopolRatingBlock } from "@/schemas/template/blocks/ratingBlockSchema";

  import { TTabsToggle, TInput } from "@topol/twig-ui";
  import { computed } from "vue";

  const mjmlStore = useMjmlStore();
  const { nullable } = useBlockAttr({
    mode: "active-group",
    group: "questionAttributes",
  });

  const padding = nullable("padding");

  const question = computed(() => {
    const block = mjmlStore.getActiveBlock as TopolRatingBlock;
    if (!block || !block.questionAttributes) return {} as any;
    return block.questionAttributes as any;
  });

  const questionText = computed({
    get() {
      return mjmlStore.getActiveBlockPropString("questionText") || "";
    },
    set(val) {
      mjmlStore.updateBlockProp({
        prop: "questionText",
        value: val,
      });
    },
  });
  const showQuestion = computed({
    get() {
      return question.value.show;
    },
    set(val) {
      mjmlStore.updateBlockProp({
        prop: "questionAttributes",
        value: {
          ...question.value,
          show: val,
        },
      });
    },
  });
</script>
